import React, { useEffect, useState } from 'react'
import Select from 'meinian-package/src/baseComponent/select'
import request from 'meinian-package/src/utils/request'

const convert = (result) => {
  const all = []
  result.forEach((item) => {
    let parent = null
    parent = { label: item.name, value: item.name, node: 1 }
    let children = null
    if (item.children && item.children.length) {
      children = item.children.map(son => ({
        label: son.name,
        value: son.name,
        parent,
        node: 2
      }))
      parent.children = children
    }
    all.push(parent)
  })
  return all
}
export default (props) => {
  const { gender, shopStatus, ...otherProps } = props
  const [options, setOptions] = useState([])
  useEffect(() => {
    fetchCategories()
  }, [gender, shopStatus])
  const fetchCategories = async () => {
    try {
      const res = await request.get('/zhikuan/common/list-all-category', { params: { gender, shopStatus } })
      setOptions(convert(res.children))
    } catch (err) {
      console.error(err)
    }
  }

  return <Select.Tile {...otherProps} data={options} placeholder="品类" />
}
